import React from "react";

import Element from "components/Forms/Element";

interface Props {
	flexBasis: string;
	fullWidth: boolean;
	uuid: string;
	fid: string;
}

const PADDING = "10px";

const ElementWrapped = ({ flexBasis, fullWidth, uuid, fid }: Props) => {
	return (
		<div
			style={{
				flexGrow: 0,
				flexBasis,
				padding: PADDING,
			}}
			className={fullWidth ? "custom-form-width" : ""}>
			<Element fid={fid} uuid={uuid} rowIndex={0} />
		</div>
	);
};

export default ElementWrapped;
